module.exports = __webpack_public_path__ + "media/klaseaDia3K42.7bd4a94a.mp4";